import { render } from "./FlipPropertyReadyView.vue?vue&type=template&id=e2c74356&ts=true"
import script from "./FlipPropertyReadyView.vue?vue&type=script&lang=ts"
export * from "./FlipPropertyReadyView.vue?vue&type=script&lang=ts"

import "./FlipPropertyReadyView.vue?vue&type=style&index=0&id=e2c74356&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__